module.exports = __webpack_public_path__ + "static/media/inscriptions.15f1cdd8.jpg";